const getters = {
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  ganttDevice: state => state.ganttToolBar.ganttDevice,
  ganttPlan: state => state.ganttToolBar.ganttPlan,
  ganttEditMode: state => state.ganttToolBar.ganttEditMode,
  cutPlan: state => state.ganttToolBar.cutPlan,
  deviceConfigForPlan: state => state.ganttToolBar.deviceConfigForPlan,
  currentApp: state => state.account.currentApp,
  projectDevice: state => state.projectSchedule.projectDevice,
  projectPlan: state => state.projectSchedule.projectPlan,
  projectCutPlan: state => state.projectSchedule.projectCutPlan,
  batchAddShow: state => state.projectSchedule.batchAddShow,
  scheduleData: state => state.projectSchedule.scheduleData,
  allowRightDetail: state => state.projectSchedule.allowRightDetail,
  viewLayout: state => state.projectSchedule.viewLayout,
  envConfig: state => state.common.envConfig,
  headerOperate: state => state.projectSchedule.headerOperate,
  inSearch: state => state.projectSchedule.inSearch,
  batchEditShow: state => state.projectSchedule.batchEditShow,
  selectedBatchList: state => state.projectSchedule.selectedBatchList
};
export default getters;
